/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubmissionId } from './submissionId';
import type { SubmissionTaskId } from './submissionTaskId';
import type { SubmissionUserId } from './submissionUserId';
import type { SubmissionModuleId } from './submissionModuleId';
import type { SubmissionText } from './submissionText';
import type { SubmissionAttachments } from './submissionAttachments';
import type { SubmissionEvaluation } from './submissionEvaluation';
import type { SubmissionOralExamEvaluation } from './submissionOralExamEvaluation';
import type { SubmissionEvaluationStudentFeedback } from './submissionEvaluationStudentFeedback';
import type { SubmissionEvaluationFormativeFeedback } from './submissionEvaluationFormativeFeedback';
import type { SubmissionFeedback } from './submissionFeedback';
import type { SubmissionMcqResult } from './submissionMcqResult';
import type { SubmissionOralExamSession } from './submissionOralExamSession';
import type { SubmissionCreatedAt } from './submissionCreatedAt';
import type { SubmissionModifiedAt } from './submissionModifiedAt';
import type { SubmissionEtag } from './submissionEtag';
import type { SubmissionEtagReconciledFromStaleClient } from './submissionEtagReconciledFromStaleClient';

/**
 * Submission
 */
export interface Submission {
  id?: SubmissionId;
  taskId?: SubmissionTaskId;
  userId?: SubmissionUserId;
  moduleId?: SubmissionModuleId;
  state?: string;
  text?: SubmissionText;
  attachments?: SubmissionAttachments;
  evaluation?: SubmissionEvaluation;
  oralExamEvaluation?: SubmissionOralExamEvaluation;
  evaluationStudentFeedback?: SubmissionEvaluationStudentFeedback;
  evaluationFormativeFeedback?: SubmissionEvaluationFormativeFeedback;
  feedback?: SubmissionFeedback;
  mcqResult?: SubmissionMcqResult;
  oralExamSession?: SubmissionOralExamSession;
  createdAt?: SubmissionCreatedAt;
  modifiedAt?: SubmissionModifiedAt;
  /** ETag for optimistic concurrency control. */
  etag?: SubmissionEtag;
  /** True when the request's lastKnownEtag lagged the server and the save reconciled. */
  etagReconciledFromStaleClient?: SubmissionEtagReconciledFromStaleClient;
}
